import { render, staticRenderFns } from "./Whoweare.vue?vue&type=template&id=04022038&scoped=true&"
import script from "./Whoweare.vue?vue&type=script&lang=js&"
export * from "./Whoweare.vue?vue&type=script&lang=js&"
import style0 from "./Whoweare.vue?vue&type=style&index=0&id=04022038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04022038",
  null
  
)

export default component.exports